import images from 'assets/images/images'
import Modal from 'containers/modal/Modal'
import useTranslate from 'hooks/useTranslate'
import React from 'react'

const ApprovalModal = ({ onClose, title, desc, closeModal, onApproval, loading=false, disabledButtons= false, children }) => {
    const {t} = useTranslate()
  return (
    <Modal onClose={onClose} headerShow modalContainerClass='approval' mmodalClass='modal-medium' closeModal={closeModal} >
        <img className='approval-attention' src={images.attention} alt="" />
        <div className="approval-body">
            {
                title && <div className="approval-body-title">
                    {title}
                </div>
            }
            {
                desc && <div className="approval-body-desc">
                    {desc}
                </div>
            }
            {children}
            {
                !disabledButtons && <div className="approval-buttons">
                <button onClick={closeModal} disabled={loading} className="btn-primary-outline">{t('cancel')}</button>
                <button onClick={onApproval} disabled={loading} className="btn-primary">{loading ? <div className='spinner-white'/> : t('approve')}</button>
            </div>
            }
        </div>
    </Modal>
  )
}

export default ApprovalModal